import App from "./App.svelte";
import "./htmlSvelteInjectors";

const app = new App({
  target: document.getElementById("svelte-app"),
});

export default app;
